// extracted by mini-css-extract-plugin
export default {"SelectItem":"_SelectItem--re3jX","Selected":"_Selected--aztsZ","SelectTrigger":"_SelectTrigger--SMQW_","SelectContent":"_SelectContent--Ygt8o"};